document.addEventListener('DOMContentLoaded', () => {
	const btn = document.querySelector('.video-popup-btn');
	const modal = document.getElementById('video-modal');
	if (!btn || !modal) return;

	const video = modal.querySelector('video');
	const closeBtn = modal.querySelector('.video-modal-close');

	if (!btn.hasAttribute('href')) {
		btn.setAttribute('tabindex', '0');
		btn.setAttribute('role', 'button');
	}

	function trapFocus(e) {
		if (e.key !== 'Tab') return;
		const focusable = Array.from(modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'));
		if (!focusable.length) return;
		if (e.shiftKey && document.activeElement === focusable[0]) {
			e.preventDefault();
			focusable[focusable.length - 1].focus();
		}
	}

	function handleFocusEscape(e) {
		if (!modal.contains(e.target)) {
			closeBtn.focus();
		}
	}

	function openModal() {
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		video.play();
		closeBtn.focus();
		modal.addEventListener('keydown', trapFocus);
		document.addEventListener('focusin', handleFocusEscape);
	}

	function closeModal() {
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		video.pause();
		video.currentTime = 0;
		btn.focus();
		modal.removeEventListener('keydown', trapFocus);
		document.removeEventListener('focusin', handleFocusEscape);
	}

	btn.addEventListener('click', (e) => {
		e.preventDefault();
		openModal();
	});

	btn.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			openModal();
		}
	});

	closeBtn.addEventListener('click', closeModal);

	modal.addEventListener('click', (e) => {
		if (e.target === modal) closeModal();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
	});
});
